'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _colors = require('HubStyleTokens/colors');

var _ImmutableMerchandiseIdMap = require('self-service-api/constants/ImmutableMerchandiseIdMap');

var _ImmutableMerchandiseIdMap2 = _interopRequireDefault(_ImmutableMerchandiseIdMap);

var _GrowthSuiteCatalogTableCell = require('pricing-pages-unified-ui/components/growth-suite-catalog/GrowthSuiteCatalogTableCell');

var _GrowthSuiteCatalogTableCell2 = _interopRequireDefault(_GrowthSuiteCatalogTableCell);

var _SuiteEditionMerchIdMap = require('pricing-pages-unified-ui/constants/SuiteEditionMerchIdMap');

var _SuiteEditionMerchIdMap2 = _interopRequireDefault(_SuiteEditionMerchIdMap);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TableRow = _styledComponents2.default.tr.withConfig({
  displayName: 'GrowthSuiteCatalogFeaturesTable__TableRow'
})([':nth-child(even){background-color:', ';:hover{background-color:', ';}& > th{background-color:', ';}}:nth-child(odd){background-color:', ';:hover{background-color:', ';}& > th{background-color:', ';}}'], _colors.OLAF, _colors.OLAF, _colors.OLAF, _colors.GYPSUM, _colors.GYPSUM, _colors.GYPSUM);

var Table = _styledComponents2.default.table.withConfig({
  displayName: 'GrowthSuiteCatalogFeaturesTable__Table'
})(['border-spacing:0;width:100%;margin-bottom:0;']);

var GrowthSuiteCatalogFeaturesTable = function GrowthSuiteCatalogFeaturesTable(_ref) {
  var edition = _ref.edition,
      hub = _ref.hub;

  var merchIdForHubEdition = _SuiteEditionMerchIdMap2.default[edition][hub];

  var featureIds = Object.keys(_ImmutableMerchandiseIdMap2.default[merchIdForHubEdition].features);

  // this logic splits the features list almost in half (but with 2 or 3 more features in the first half
  // so they will appear in two columns,  with 2 or 3 empty right side columns
  var leftSideFeatures = featureIds.slice(0, Math.ceil((featureIds.length + 2) / 2));
  var rightSideFeatures = featureIds.slice(Math.ceil((featureIds.length + 2) / 2));

  return _react2.default.createElement(
    Table,
    null,
    _react2.default.createElement(
      'tbody',
      null,
      leftSideFeatures.map(function (_, i) {
        return _react2.default.createElement(
          TableRow,
          { key: i },
          _react2.default.createElement(_GrowthSuiteCatalogTableCell2.default, {
            merchandiseId: merchIdForHubEdition,
            featureId: leftSideFeatures[i],
            key: leftSideFeatures[i],
            hub: hub
          }),
          _react2.default.createElement(_GrowthSuiteCatalogTableCell2.default, {
            merchandiseId: merchIdForHubEdition,
            featureId: rightSideFeatures[i] || null,
            key: rightSideFeatures[i] || i,
            hub: hub
          })
        );
      })
    )
  );
};

exports.default = GrowthSuiteCatalogFeaturesTable;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./js/components/growth-suite-catalog/GrowthSuiteCatalogFeaturesTable.js
// module id = 778
// module chunks = 3 4